import { render, staticRenderFns } from "./orderConfirm.vue?vue&type=template&id=582898e2&scoped=true"
import script from "./orderConfirm.vue?vue&type=script&lang=js"
export * from "./orderConfirm.vue?vue&type=script&lang=js"
import style0 from "./orderConfirm.vue?vue&type=style&index=0&id=582898e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582898e2",
  null
  
)

export default component.exports